module.exports = __webpack_public_path__ + "img/analytics.20ffafe6.svg";